<div class="flex flex-col h-full rounded-16 overflow-hidden w-full shadow-card">
  <div class="w-full flex gap-1 py-4 px-5 items-center bg-grey-5">
    <img [src]="image()" alt="{{ title() }}" class="w-5 h-5" />
    <h2 class="text-16 font-bold font-roboto-700 text-grey-1 md:text-20">
      {{ title() }}
    </h2>
  </div>
  <ng-content></ng-content>
</div>
